<template>
    <div class="page-dashboard scrollable only-y">
        <el-row class="mt-0" :gutter="30">
            <el-col :lg="24" :md="24" :sm="24" :xs="24">
                <el-divider content-position="left">
                    Aktif Sipariş Bilgileri
                </el-divider>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="card-base card-shadow--medium mb-30">
                    <div class="p-20 flex justify-space-between">
                        <div>
                            <h3 class="mv-0 animated fadeInDown">Onay Bekleyen Siparişler</h3>
                        </div>
                    </div>
                    <div v-if="onayBekleyenSiparisList.length > 0">
                        <table class="styled striped">
                            <thead>
                            <tr>
                                <th style="min-width:85px;">İsim Soyisim</th>
                                <th style="min-width:80px;">Toplam Fiyat</th>
                                <th style="min-width:80px;">Sipariş Yeri</th>
                                <th style="min-width:80px;">Ödeme Şekli</th>
                                <th style="min-width:80px;" align="right">İşlem</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in onayBekleyenSiparisList" :key="item.msiparisId">
                                <td style="min-width:80px;">{{item.adSoyad !== '' ? item.adSoyad : '-'}}</td>
                                <td style="min-width:80px;">{{item.toplamFiyat}} CHF</td>
                                <td style="min-width:80px;">{{item.siparisYeri}}</td>
                                <td style="min-width:80px;">
                                    <div v-if="item.odemeSekli === '1'">Nakit</div>
                                    <div v-else-if="item.odemeSekli === '2'">Kredi Kartı</div>
                                    <div v-else-if="item.odemeSekli === '3'">Bedelsiz</div>
                                    <div v-else-if="item.odemeSekli === '4'">Online</div>
                                </td>
                                <td style="min-width:80px;" align="right">
                                    <div>
                                        <el-button v-on:click="siparisIptal(item.msiparisId)" type="text" size="small" style="color: #f56c6c">
                                            <i class="mdi mdi-close mdi-18px"></i> İptal Et
                                        </el-button>
                                        <el-button type="text" v-on:click="siparisHazirlaniyor(item.msiparisId)" size="small" style="color: #67c23a">
                                            <i class="mdi mdi-check mdi-18px"></i> Onayla
                                        </el-button>
                                        <el-button type="text" v-on:click="getSiparisDetay(item.msiparisId)" size="small" style="color: #64b1e2">
                                            <i class="mdi mdi-printer mdi-18px"></i> Yazdır
                                        </el-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center mb-20" v-else>
                        Veri Yok
                    </div>

                </div>
            </el-col>


            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="card-base card-shadow--medium mb-30">
                    <div class="p-20 flex justify-space-between">
                        <div>
                            <h3 class="mv-0 animated fadeInDown">Hazırlanmakta Olan Siparişler</h3>
                        </div>
                    </div>
                    <div v-if="hazirlanmaktaSiparisList.length > 0">
                        <table class="styled striped">
                            <thead>
                            <tr>
                                <th style="min-width:85px;">İsim Soyisim</th>
                                <th style="min-width:80px;">Toplam Fiyat</th>
                                <th style="min-width:80px;">Sipariş Yeri</th>
                                <th style="min-width:80px;">Ödeme Şekli</th>
                                <th style="min-width:80px;" align="right">İşlem</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in hazirlanmaktaSiparisList" :key="item.msiparisId">
                                <td style="min-width:80px;">{{item.adSoyad !== '' ? item.adSoyad : '-'}}</td>
                                <td style="min-width:80px;">{{item.toplamFiyat}} CHF</td>
                                <td style="min-width:80px;">{{item.siparisYeri}}</td>
                                <td style="min-width:80px;">
                                    <div v-if="item.odemeSekli === '1'">Nakit</div>
                                    <div v-else-if="item.odemeSekli === '2'">Kredi Kartı</div>
                                    <div v-else-if="item.odemeSekli === '3'">Bedelsiz</div>
                                    <div v-else-if="item.odemeSekli === '4'">Online</div>
                                </td>
                                <td style="min-width:80px;" align="right">
                                    <div>
                                        <el-button type="text" v-on:click="siparisYolda(item.msiparisId)" size="small" style="color: #67c23a">
                                            <i class="mdi mdi-check mdi-18px"></i> Onayla
                                        </el-button>
                                        <el-button type="text" v-on:click="getSiparisDetay(item.msiparisId)" size="small" style="color: #64b1e2">
                                            <i class="mdi mdi-printer mdi-18px"></i> Yazdır
                                        </el-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center mb-20" v-else>
                        Veri Yok
                    </div>

                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="card-base card-shadow--medium mb-30">
                    <div class="p-20 flex justify-space-between">
                        <div>
                            <h3 class="mv-0 animated fadeInDown">Yolda Olan Siparişler</h3>
                        </div>
                    </div>

                    <div v-if="yoldaSiparisList.length > 0">
                        <table class="styled striped">
                            <thead>
                            <tr>
                                <th style="min-width:85px;">İsim Soyisim</th>
                                <th style="min-width:80px;">Toplam Fiyat</th>
                                <th style="min-width:80px;">Sipariş Yeri</th>
                                <th style="min-width:80px;">Ödeme Şekli</th>
                                <th style="min-width:80px;" align="right">İşlem</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in yoldaSiparisList" :key="item.msiparisId">
                                <td style="min-width:80px;">{{item.adSoyad !== '' ? item.adSoyad : '-'}}</td>
                                <td style="min-width:80px;">{{item.toplamFiyat}} CHF</td>
                                <td style="min-width:80px;">{{item.siparisYeri}}</td>
                                <td style="min-width:80px;">
                                    <div v-if="item.odemeSekli === '1'">Nakit</div>
                                    <div v-else-if="item.odemeSekli === '2'">Kredi Kartı</div>
                                    <div v-else-if="item.odemeSekli === '3'">Bedelsiz</div>
                                    <div v-else-if="item.odemeSekli === '4'">Online</div>
                                </td>
                                <td style="min-width:80px;" align="right">
                                    <div>
                                        <el-button type="text" v-on:click="siparisTamamlandi(item.msiparisId)" size="small" style="color: #67c23a">
                                            <i class="mdi mdi-check mdi-18px"></i> Onayla
                                        </el-button>
                                        <el-button type="text" v-on:click="getSiparisDetay(item.msiparisId)" size="small" style="color: #64b1e2">
                                            <i class="mdi mdi-printer mdi-18px"></i> Yazdır
                                        </el-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center mb-20" v-else>
                        Veri Yok
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row class="mt-30" :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium widget small-widget animasyon1" v-loading="!asyncComponent">
                    <div class="widget-header ph-20 pt-20">
                        <h3 class="margin-top-5 margin-bottom-10">Dün</h3>
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-calendar-today fs-40" style="color: #d31d1c"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Sipariş Sayısı</div>
                                <h1 class="m-0 text-truncate satisSayisiDun" :data-sayi-sonu="satisSayisiDun">0</h1>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Kazanç</div>
                                <h1 class="m-0 text-truncate satisGeliriDun" :data-sayi-sonu="satisGeliriDun">0</h1>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'line'"
                               :options='{ width: "100%", height: 80, fill: "#d31d1c", stroke: "#5f2c39" }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 11, 12, 13, 12, 12, 14].toString()"/>
                </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium widget small-widget animasyon2" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <h3 class="margin-top-5 margin-bottom-10">Bugün</h3>
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-calendar fs-40" style="color: #d31d1c"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Sipariş Sayısı</div>
                                <h1 class="m-0 text-truncate satisSayisiBugun" :data-sayi-sonu="satisSayisiBugun">0</h1>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Kazanç</div>
                                <h1 class="m-0 text-truncate satisGeliriBugun" :data-sayi-sonu="satisGeliriBugun">0</h1>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#d31d1c"] }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
                </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium widget small-widget animasyon3" v-loading="!asyncComponent">
                    <div class="widget-header ph-20 pt-20">
                        <h3 class="margin-top-5 margin-bottom-10">Hafta</h3>
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-calendar-range fs-40" style="color: #d31d1c"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Sipariş Sayısı</div>
                                <h1 class="m-0 text-truncate satisSayisiBuHafta" :data-sayi-sonu="satisSayisiBuHafta">0</h1>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Kazanç</div>
                                <h1 class="m-0 text-truncate satisGeliriBuHafta" :data-sayi-sonu="satisGeliriBuHafta">0</h1>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'line'"
                               :options='{ width: "100%", height: 80, fill: "#d31d1c", stroke: "#5f2c39" }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 11, 12, 13, 12, 12, 14].toString()"/>
                </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="card-base card-shadow--medium widget small-widget animasyon4" v-loading="!asyncComponent">

                    <div class="widget-header ph-20 pt-20">
                        <h3 class="margin-top-5 margin-bottom-10">Ay</h3>
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-calendar-month fs-40" style="color: #d31d1c"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Sipariş Sayısı</div>
                                <h1 class="m-0 text-truncate satisSayisiBuAy" :data-sayi-sonu="satisSayisiBuAy">0</h1>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Kazanç</div>
                                <h1 class="m-0 text-truncate satisGeliriBuAy" :data-sayi-sonu="satisGeliriBuAy">0</h1>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#d31d1c"] }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
                </div>
            </el-col>
        </el-row>
        <el-row class="mt-30" :gutter="30">
            <el-col :lg="24" :md="24" :sm="24" :xs="24">
                <el-divider content-position="left">
                    Platform Sipariş Bilgileri
                </el-divider>
            </el-col>

            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                <div v-on:click="route('Sipariş Listesi')" class="card-base card-shadow--medium widget small-widget animasyon5" v-loading="!asyncComponent" style="cursor: pointer">

                    <div class="widget-header ph-20 pt-20">
                        <h3 class="margin-top-5 margin-bottom-10">Mobil</h3>
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-cellphone fs-40" style="color: #d31d1c"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Sipariş Sayısı</div>
                                <h1 class="m-0 text-truncate">{{satisSayisiMobil}}</h1>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Kazanç</div>
                                <h1 class="m-0 text-truncate">{{satisGeliriMobil}} CHF</h1>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#d31d1c"] }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
                </div>
            </el-col>

            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                <div v-on:click="route('Sipariş Listesi')" class="card-base card-shadow--medium widget small-widget animasyon5" v-loading="!asyncComponent" style="cursor: pointer">

                    <div class="widget-header ph-20 pt-20">
                        <h3 class="margin-top-5 margin-bottom-10">Kasa</h3>
                        <div class="flex justify-center align-center">
                            <div class="widget-icon-box mr-20 animated fadeInRight">
                                <i class="widget-icon mdi mdi-cash-register fs-40" style="color: #d31d1c"></i>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Sipariş Sayısı</div>
                                <h1 class="m-0 text-truncate">{{satisSayisiKasa}}</h1>
                            </div>
                            <div class="widget-info box grow text-truncate animated fadeInLeft">
                                <div class="o-050 widget-title text-truncate pt-5">Kazanç</div>
                                <h1 class="m-0 text-truncate">{{satisGeliriKasa}} CHF</h1>
                            </div>
                        </div>
                    </div>
                    <component :is="asyncComponent" :type="'bar'"
                               :options='{ width: "100%", height: 80, fill: ["#d31d1c"] }'
                               :data="[1, 3, 2, 4, 4, 9, 3, 4, 6, 5, 4, 6, 9, 8, 7, 6, 5, 12, 10, 9].toString()"/>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="inputDialog"
                width="30%"
                center>
            <span style="width: 100%; display: block">
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="text-center">
                        Sipariş hazırlanması için tahmini süre seçiniz
                    </el-col>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                       <el-row :gutter="10">
                           <el-col :lg="8" :md="8" :sm="24" :xs="24" class="mt-10">
                                <el-radio v-model="sureInput" label="10" border>10 Dakika</el-radio>
                           </el-col>
                           <el-col :lg="8" :md="8" :sm="24" :xs="24" class="mt-10">
                               <el-radio v-model="sureInput" label="20" border>20 Dakika</el-radio>
                           </el-col>
                           <el-col :lg="8" :md="8" :sm="24" :xs="24" class="mt-10">
                                <el-radio v-model="sureInput" label="30" border>30 Dakika</el-radio>
                           </el-col>
                           <el-col :lg="8" :md="8" :sm="24" :xs="24" class="mt-10">
                                <el-radio v-model="sureInput" label="40" border>40 Dakika</el-radio>
                           </el-col>
                           <el-col :lg="8" :md="8" :sm="24" :xs="24" class="mt-10">
                                <el-radio v-model="sureInput" label="50" border>50 Dakika</el-radio>
                           </el-col>
                           <el-col :lg="8" :md="8" :sm="24" :xs="24" class="mt-10">
                                <el-radio v-model="sureInput" label="60" border>60 Dakika</el-radio>
                           </el-col>
                       </el-row>
                    </el-col>
                </el-row>
            </span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="siparisHazir(), inputDialog = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="inputDialog = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                title='Sipariş Detay'
                :visible.sync="detayModal"
                width="60%"
                center>
            <span style="width: 100%; display: block">
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="fisAlani">
                            <el-row style="margin-bottom: 10px">
                                <div class="altUstBorder">
                                    <el-col :span="24">
                                        <div v-if="detayBilgiler.adSoyad !==''">
                                            <div class="fonts-16" style="font-weight: bold">
                                                {{detayBilgiler.adSoyad}}
                                            </div>
                                        </div>
                                    </el-col>

                                    <el-col :span="24">
                                        <div v-if="detayBilgiler.adres !==''">
                                            <div class="fonts-16">
                                                {{detayBilgiler.adres}}
                                            </div>
                                        </div>
                                    </el-col>

                                    <el-col :span="24">
                                        <div v-if="detayBilgiler.ilce !==''">
                                            <div class="fonts-16">
                                                {{detayBilgiler.ilce}}
                                            </div>
                                        </div>
                                    </el-col>

                                    <el-col :span="24">
                                        <div v-if="detayBilgiler.telefon !==''">
                                            <div class="fonts-16">
                                                {{detayBilgiler.telefon}}
                                            </div>
                                        </div>
                                    </el-col>

                                </div>
                            </el-row>
                            <el-row class="ozelBorder">
                                <el-col :span="16" class="ozelPadding borderRight boldYazi fonts-16">Produktname</el-col>
                                <el-col :span="4" class="ozelPadding borderRight ortala boldYazi fonts-16">Menge</el-col>
                                <el-col :span="4" class="ozelPadding ortala boldYazi sag fonts-16">Betrag</el-col>
                            </el-row>
                            <div v-for="(item,index) in detayList" :key="index" class="icRowDiv">
                                <el-row class="icRow">
                                    <el-col :span="16" class="ozelPadding borderRight fonts-16">
                                        {{ item.urunAdi + (item.katBaslik.includes('32') || item.katBaslik.includes('40') ? '(' + item.katBaslik + ')' : '')}}
                                    </el-col>
                                    <el-col :span="4" class="ozelPadding borderRight ortala fonts-16">{{item.adet}}</el-col>
                                    <el-col :span="4" class="ozelPadding ortala sag fonts-16">{{item.toplamFiyat}} CHF</el-col>
                                    <el-col :span="24" v-if="item.malzeme.length>0">
                                        <div class="boldYazi ekYer" style="background: #f1f1f1">
                                            <div v-for="(i, index) in item.malzeme" :key="index">
                                                <span v-if="i.durum == 0 ">
                                                    {{i.malzemeAdi}}
                                                    <div class="fiyatBilgisi fiyatBilgisiRed fonts-14">
                                                       X
                                                    </div>
                                                </span>
                                                <span v-else>
                                                    {{i.malzemeAdi}}
                                                    <div class="fiyatBilgisi fonts-14">
                                                       {{i.fiyat !== 0 ? i.fiyat : ' - '}} CHF
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-col :span="24" class="ozelBorder" style="background-color: #fff">
                                <div class="ozelPadding altCizgi" style="justify-content: space-between">
                                    <div class="fonts-16"> Bestellübersicht:</div>
                                    <div class="fonts-16">{{toplamAdet}} Produkt</div>
                                </div>

                                <div class="ozelPaddingv2">
                                    <div class="ortaYazi">Betrag</div>
                                    <div class="ortaYazi boldYazi">{{toplamTutar}} CHF</div>
                                </div>
                            </el-col>
                            <el-col :span="24" style="border: 1px solid #4b5264;border-top: 0; background-color: #ffffff" class="toplamBolgesi">
                                <div class="ozelPaddingv2">
                                    <span class="ortaYazi">Gesamt <br> Betrag</span>
                                    <span class="sonTutar">{{toplamTutar}} CHF</span>
                                </div>
                            </el-col>
                            <el-row>
                                 <el-col :span="24">
                                     <div class="altUstBorder" style="margin-top: 5px !important;">
                                         <div v-if="detayBilgiler.odemeSekli !=='' || detayBilgiler.odemeSekli">
                                            <div class="fonts-16">
                                                <span style="font-weight: bold">Zahlungsmethode:</span> {{detayBilgiler.odemeSekli === '1' ? 'Kasse' : (detayBilgiler.odemeSekli === '2' ? 'Karte' : 'Test')}}
                                            </div>
                                        </div>
                                         <div v-if="detayBilgiler.siparisNotu !== '' || detayBilgiler.siparisNotu">
                                            <div class="fonts-16">
                                                <span style="font-weight: bold">Anmerkungen :</span> {{detayBilgiler.siparisNotu}}
                                            </div>
                                         </div>
                                    </div>
                                 </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
            </span>
            <span slot="footer" class="dialog-footer">
                    <el-button type="success"
                               size="mini"
                               @click="fisCikti(detayBilgiler.siparisSuresi), detayModal = false">
                        <i class="mdi mdi-printer"></i> Yazdır
                    </el-button>
                    <el-button size="mini" type="danger"
                               @click="detayModal = false">
                        <i class="mdi mdi-close"></i>
                    </el-button>
                </span>
        </el-dialog>
        
    </div>

</template>

<script>
    import notification from '../../notification'
    import musteriService from "../../WSProvider/MusteriService";
    import haberService from "../../WSProvider/HaberService";
    import JQuery from 'jquery'
    import sayfaService from "../../WSProvider/SayfaService";
    import urunService from "../../WSProvider/UrunService";
    import moment from 'moment-timezone'
    let $ = JQuery;

    import EventBus from '@/components/event-bus'
    

    export default {
        name: 'Dashboard',
        data() {
            return {
                count: {
                    urun:'',
                    urunKategori:'',
                    sayfa:'',
                    bulten:'',
                },
                asyncComponent: 'peity',
                asyncChart1: true,
                chart1: null,
                pie: null,
                hazirlanmaktaSiparisList: [],
                onayBekleyenSiparisList: [],
                yoldaSiparisList: [],
                radio1: 'Month',
                radio2: 'Week',

                satisSayisiDun: '',
                satisSayisiBugun: '',
                satisSayisiBuHafta: '',
                satisSayisiBuAy: '',
                satisSayisiMobil:'',
                satisSayisiKasa:'',


                satisGeliriDun: '',
                satisGeliriBugun: '',
                satisGeliriBuHafta: '',
                satisGeliriBuAy: '',
                satisGeliriMobil:'',
                satisGeliriKasa:'',


                guncellenecekSiparisId: '',
                inputDialog: false,
                sureInput: '',

                detayModal: false,
                detayList: [],
                toplamTutar: '',
                toplamAdet: 0,

                detayBilgiler: '',

            }
        },
        methods: {
            fisCikti(val){
                let dakika = parseInt(val);
                barkodCikti(dakika)
            },
            getSiparisDetay(val){
                let self = this;
                this.toplamAdet= 0;
                musteriService.siparisDetay(val).then((response) => {
                    if (response.status === 200) {
                        response.data.urun.forEach(function (e) {
                            self.toplamAdet += parseInt(e.adet)
                        });
                        this.toplamTutar = response.data.toplamFiyat;
                        this.detayList = response.data.urun;
                        this.detayBilgiler = response.data;
                        this.detayModal = true
                        // console.log("Sipariş detay : ", response)
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            siparisIptal(val){
                musteriService.siparisDurumGuncelle(val, '0').then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Sipariş iptal edildi");
                        this.islemListesi()
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            siparisYolda(val){
                musteriService.siparisDurumGuncelle(val, '5').then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Sipariş yola çıktı");
                        this.islemListesi()
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            siparisTamamlandi(val){
                musteriService.siparisDurumGuncelle(val, '1').then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Sipariş teslim edildi");
                        this.islemListesi()
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            siparisHazirlaniyor(val){
                this.guncellenecekSiparisId = val;
                this.inputDialog = true;
            },
            siparisHazir(){
                musteriService.siparisDurumGuncelle(this.guncellenecekSiparisId, '4', this.sureInput).then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Sipariş hazırlanıyor");
                        this.islemListesi();
                        this.guncellenecekSiparisId = '';
                        this.sureInput = ''
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            route(name) {
                var tabList = this.$store.state.tabList;
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            destroyChart1() {
                if (this.chart1) {
                    this.chart1.dispose()
                    this.chart1 = null
                }
            },
            sayiSay(classAdi, sure, gecikme,sonEk) {
                setTimeout(function () {
                    var $this = $('.' + classAdi),
                        kacaSaysin = $this.attr('data-sayi-sonu');
                    $({sayacSon: $this.text()}).animate({sayacSon: kacaSaysin},
                        {
                            duration: sure ? sure : 1500,
                            easing: 'linear',
                            step: function () {
                                $this.text(sonEk ? Math.floor(this.sayacSon)+' '+ sonEk : Math.floor(this.sayacSon));
                                // $this.text(Math.floor(this.sayacSon));
                            },
                            complete: function () {
                                $this.text(sonEk ? this.sayacSon+' '+ sonEk : this.sayacSon);
                                // $this.text(this.sayacSon);
                            }
                        });
                },gecikme ? gecikme : 100)
            },

            getSatisSayisi() {
                musteriService.siparisCountDashboard().then((response) => {
                    if (response.status === 200) {
                        this.satisSayisiDun = response.dun;
                        this.satisSayisiBugun = response.bugun;
                        this.satisSayisiBuHafta = response.yediGun;
                        this.satisSayisiBuAy = response.otuzGun;
                        this.satisSayisiMobil = response.mobilBugun;
                        this.satisSayisiKasa = response.kasaBugun;
                        this.sayiSay('satisSayisiDun','',600);
                        this.sayiSay('satisSayisiBugun','',900);
                        this.sayiSay('satisSayisiBuHafta','',1200);
                        this.sayiSay('satisSayisiBuAy','',1500);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            getSatisGelir() {
                musteriService.siparisToplamDashboard().then((response) => {
                    if (response.status === 200) {
                        this.satisGeliriDun = response.dun;
                        this.satisGeliriBugun = response.bugun;
                        this.satisGeliriBuHafta = response.yediGun;
                        this.satisGeliriBuAy = response.otuzGun;
                        this.satisGeliriMobil = response.mobilBugun;
                        this.satisGeliriKasa = response.kasaBugun;
                        this.sayiSay('satisGeliriDun','',600,'CHF');
                        this.sayiSay('satisGeliriBugun','',900,'CHF');
                        this.sayiSay('satisGeliriBuHafta','',1200,'CHF');
                        this.sayiSay('satisGeliriBuAy','',1500,'CHF');
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },

            islemListesi() {
                //onay bekliyor.
                musteriService.siparisListesi(0, 10,"2").then((response) => {
                    if (response.status === 200) {
                        this.onayBekleyenSiparisList = response.data;
                        
                        if(this.$store.getters.getTabList.length == 0 && !this.$store.getters.getZilAcildiMi) EventBus.$emit("zilBildirimGetir", true);
                    } else {
                        notification.Status(response.status, this)
                    }
                });
                //hazırlanıyor
                musteriService.siparisListesi(0, 10,"4").then((response) => {
                    if (response.status === 200) {
                        this.hazirlanmaktaSiparisList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
                //yolda
                musteriService.siparisListesi(0, 10,"5").then((response) => {
                    if (response.status === 200) {
                        this.yoldaSiparisList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            getCount() {
                haberService.haberCount(1).then((response) => {
                    if (response.status === 200) {
                        this.count.bulten = response.data.count;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
                sayfaService.sayfaCount(1).then((response) => {
                    if (response.status === 200) {
                        this.count.sayfa = response.data.count;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
                urunService.ukategoriList(1).then((response) => {
                    if (response.status === 200) {
                        this.count.urunKategori = response.data.length;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
                urunService.urunListesi(1,'','').then((response) => {
                    if (response.status === 200) {
                        this.count.urun = response.data.length;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            }
        },
        mounted() {
            const self = this;

            this.getCount();
            this.islemListesi();
            this.getSatisSayisi();
            this.getSatisGelir();

            EventBus.$on("onayBekleyenlerGuncelle", function(bool){
                if(bool){
                    musteriService.siparisListesi(0, 10,"2").then((response) => {
                        if (response.status === 200) {
                            self.onayBekleyenSiparisList = response.data;
                        } else {
                            notification.Status(response.status, self)
                        }
                    });
                }
            })

        },  
        beforeDestroy() {
            this.destroyChart1()
            if (!this.pie) {
                return
            }
            this.pie.dispose()
            this.pie = null
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
    function barkodCikti(gelenSiparisSuresi) {
        const ciktiCSS = `
        div{
            border: none !important;
            padding:0 !important;
            margin: 0 !important;
            display: inline-block
        }
        body {
            margin: 0 ;
            padding:0 0.5cm;
            width:7.2cm;
            font-family: monospace;
            font-size:14px
        }
        @page {
            margin: 0 9mm
        }
        .ozelPaddingv2 {
            display: flex;
            justify-content:space-between
        }
        .el-col-24 {
            width: 100%
        }
        .el-col-16 {
            width: 66.66667%;
        }
        .el-col-14 {
            width: 66.66667%;
        }
        .el-col-4 {
            width: 16.66667%;
        }
        .el-col-2 {
            display: none
        }
        .el-col-20 {
            width: 83.33333%;
        }
        .FisBosluk {
            display: block
        }
        .ozelBorder {
            border-bottom: 1px solid #000 !important;
            margin-bottom: 5px !important;
            padding-bottom: 5px !important;
        }
        .el-row {
            display: block;
            width:100%
        }
        .ortala {
            text-align:center;
            justify-content:center;
        }
        br {
            display:none
        }
        .icRowDiv {
            display: block
        }
        .boldYazi {
            font-weight: bold
        }
        .sag {
            text-align:right
        }
        .ekYer {
            background:transparent !important;
            margin-bottom: 5px!important;
            display:block;
            padding-left: 10px !important;
        }
        .ekYer div {
            display:block
        }
        .icRowDiv .icRow{
            border-bottom: 1px solid #000 !important;
            margin-bottom: 5px !important;
            padding-bottom: 5px !important;
        }
        .toplamBolgesi {
            font-weight: bold
        }
        .fiyatBilgisi {
            float:right;
            padding-right: 2px !important;
        }
        .altCizgi {
            display: none
        }
        .muhittin {
            display: block; float: left;
        }
        .altUstBorder {
            border-bottom: 1px solid #aaa !important;
            border-top: 1px solid #aaa !important;
            margin-bottom: 5px !important;
            padding: 5px 0 !important;
            display: block !important;
        }
    `;
        var openWindow = window.open("", "", "_blank,width=400,height=500");
        const tarih = moment().format('yyyy/MM/DD');
        const saat = moment().subtract(1, 'hours').format('HH:mm');
        const siparisSuresi = moment().add(gelenSiparisSuresi, 'minutes').format('HH:mm');
        const logo = '<img src="static/logo3.png" alt="logo" style="max-width: 100%; height: 50px"/>';
        openWindow.document.write('<div class="ortala" style="display: block !important;margin-top: 10px !important;filter: brightness(0)">' + logo + '</div>');
        openWindow.document.write('<div class="ortala" style="margin: 20px !important;">Aarauerstrasse 21 5116 Schinznach-Bad, <br style="display: block !important;"><br style="display: block !important;"> Tel 056 525 91 91</div>');
        openWindow.document.write('<div class="sag" style="display: block;margin-bottom: 25px !important;"><div style="float: left">' + tarih + '</div><div style="float: right">' + saat + '</div></div>');
        openWindow.document.write('<div class="ortala" style="display: block;font-weight: bold;font-size: 20px; margin: 10px 0 !important;">Lieferung Bestätigte Zeit: '+siparisSuresi+'</div>');
        openWindow.document.write('<div class="FisBosluk">' + $(".fisAlani").html() + '</div>');
        openWindow.document.write('<style>' + ciktiCSS + '</style>');
        openWindow.document.write('<div style="display: block !important; text-align: center; margin-top: 20px !important;">MwSt. Nr. CHE-256.608.568</div>');
        openWindow.document.write('<div style="display: block !important; text-align: center; margin-top: 10px !important;">Danke für ihre Bestellung</div>');
        openWindow.focus();
        setTimeout(() => {
            openWindow.print();
        }, 1000);
        // setTimeout(() => {
        //     openWindow.close();
        // }, 1500)
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables';

    .widget {
        height: 200px;
        position: relative;

        .widget-header {

            .widget-icon-box {
                background: rgba(0, 0, 0, .02);
                border: 1px solid rgba(0, 0, 0, .02);
                border-radius: 4px;
                text-align: center;
                width: 60px;
                padding: 5px;
            }

            .widget-title {
                font-weight: bold;
            }
        }


        .badge-box {
            .badge {
                //background: rgba(0, 0, 0, .02);
                display: inline-block;
                //padding: 2px 5px;
                //border: 1px solid rgba(0, 0, 0, .02);
                border-radius: 4px;
                font-size: 80%;
            }
        }
    }

    @media (min-width: 768px) and (max-width: 1040px) {
        .radio-switcher {
            display: none;
        }

        .widget {
            .widget-header {
                .widget-icon-box {
                    display: none;
                }
            }
        }
    }

    @media (max-width: 420px) {
        .radio-switcher {
            display: none;
        }
    }
</style>

<style lang="scss">
    .bg-accent {
        background-color: #21c1d666 !important;
    }

    ;
    .page-dashboard {

        .widget {
            .peity {
                position: absolute;
                bottom: -1px;
                left: 0;
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }

        table.styled {
            .peity {
                margin-right: 10px;
            }
        }

        .vb-content {
            padding: 0 20px;
            box-sizing: border-box !important;
            margin-top: -5px;
            margin-left: -20px;
            margin-right: -20px;
            height: calc(100% + 15px) !important;
            width: calc(100% + 40px) !important;
        }
    }

    @media (max-width: 768px) {
        .page-dashboard {
            .vb-content {
                padding: 0 5px !important;
                margin: -5px;
                width: calc(100% + 10px) !important;
            }
        }
    }
</style>


<style>
    @keyframes grow {
        0% {
            transform: scaley(0)
        }
        100% {
            transform: scaley(1)
        }
    }

    @keyframes deneme {
        0% {
            opacity: 0
        }
        100% {
            opacity: 1
        }
    }

    .peity polyline {
        animation: deneme 0.3s forwards;
        opacity: 0
    }

    .peity rect,
    .peity polygon {
        transform: scaleY(0);
        animation: grow 0.3s forwards;
        transform-origin: bottom;
    }

    .animasyon1 .peity polygon {
        animation-delay: 300ms;
    }

    .animasyon1 .peity polyline {
        animation-delay: 600ms;
    }

    .animasyon2 .peity rect {
        animation-delay: 600ms;
    }

    .animasyon3 .peity polygon {
        animation-delay: 900ms;
    }

    .animasyon3 .peity polyline {
        animation-delay: 1200ms;
    }

    .animasyon4 .peity rect {
        animation-delay: 1200ms;
    }

    .animasyon5 .peity rect {
        animation-delay: 1500ms;
    }

    .animasyon6 .peity rect {
        animation-delay: 1800ms;
    }

    .el-divider__text {
        background-color: #f2f7fa;
    }
</style>

<style>
    .ozelPadding {
        padding: 0 15px;
        min-height: 44px;
        display: flex;
        align-items: center;
    }

    .ozelPaddingv2 {
        padding: 0 15px;
        min-height: 66px;
        display: flex;
        align-items: center;
        justify-content: space-between
    }

    .icRowDiv .icRow {
        border: 1px solid #4b5264;
        background: #ffffff;
        margin-top: 0 !important;
    }

    .icRowDiv .icRow:last-of-type:not(:first-of-type) {
        border-bottom: 0
    }

    .icRowDiv .icRow:first-of-type {
        border-top: 0
    }

    .ozelBorder {
        border: 1px solid #4b5264;
        background: #f1f1f1;
    }

    .borderLeft {
        border-left: 1px solid #4b5264;
    }

    .borderRight {
        border-right: 1px solid #4b5264;
    }

    .ortala {
        justify-content: center;
    }

    .boldYazi {
        font-weight: bold;
    }

    .ekYer {
        border-top: 1px solid #4b5264;
        padding-left: calc(8.33333% + 30px);
        padding-right: 28px;
        min-height: 44px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .ekYer span {
        position: relative;
        width: 100%;
        display: block;
        line-height: 22px;
    }

    .fiyatBilgisi {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    .fiyatBilgisiRed{
        color: red !important;
    }

    .ekYer span:not(:first-of-type) {
        margin-top: 5px;
    }
 /*
    .ekYer span::before {
        content: "";
        position: absolute;
        left: -10px;
        height: 8px;
        width: 8px;
        background: #4b5264;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        box-shadow: 0 0 4px 1px rgba(79, 85, 104, .4);
    }

    .ekYer span::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border-bottom: 1px dotted #4b5264;
    }
*/
    .altCizgi {
        position: relative;
    }

    .altCizgi::before {
        position: absolute;
        content: "";
        height: 1px;
        width: calc(100% - 30px);
        left: 15px;
        bottom: 0;
        background: #c9c9c9;
    }

    .ortaYazi {
        font-size: 18px !important;
    }

    .sonTutar {
        font-size: 22px !important;
        color: red;
        font-weight: bold;
    }

    .butonAyarlari {
        width: 100%;
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 16px !important;
    }

    .odemeButon {
        background: #4b5264 !important;
        border: none !important;
        color: #ffffff !important;
        border-radius: 0;
        box-shadow: 0 0 2px 10px rgba(100, 100, 100, .2);
        margin-bottom: 10px;
        width: 100%;
        display: block;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 28px !important;
    }

    .odemeAlindi {
        background: #ffffff !important;
        color: #00933e !important;
        border: none !important;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 28px !important;
        box-shadow: 0 0 8px 2px rgba(150, 150, 150, .4);
        text-transform: uppercase;
        letter-spacing: 3px;
        font-weight: bold;
    }

    .activeOdeme {

        background: #00933e !important;
        color: #ffffff !important;
        border: none !important;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 28px !important;
        box-shadow: 0 0 8px 2px rgba(150, 150, 150, .4);
        text-transform: uppercase;
        letter-spacing: 3px;
        font-weight: bold;

    }

    .el-radio-button__inner {
        width: 100%;
    }

    .odemeRadio {
        width: 100%;
    }

    .odemeRadio .el-radio-button {
        width: calc(100% / 3)
    }

    .odemeRadio .el-radio-button__inner:hover {
        color: #00933e;
    }

    .odemeRadio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #00933e;
        border-color: #00933e;
    }

    .odemeRadio .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
        color: #ffffff;
    }


    .fonts-16 {
        font-size: 16px !important;
    }

    .fonts-14 {
        font-size: 14px !important;
    }
</style>
